export var supportsLocaleOptions = () => {
  return !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function');
};
export var formatIntlLabel = (value, locale) => {
  var supportsLocale = supportsLocaleOptions();
  return supportsLocale ? (value / 100).toLocaleString(locale, {
    style: 'percent'
  }) : "".concat(value, "%");
};